<div class="user-badge-container" [ngClass]="size">
  <div class="user-badge" [class]="colorClass">{{ senderInitials }}</div>
</div>
